import { DateRange, LocationOn, Search, School, TrendingUp, People, Schedule, Lightbulb, Verified, AccessTime, HowToReg, CheckCircle, Assignment, AccessTime as TimeIcon } from '@mui/icons-material';
import { Box, Button, Grid, InputAdornment, MenuItem, Stack, TextField, Typography, useTheme, alpha, Container, Card } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { searchTutors , setFilter } from '../../state/slices/search';
import { useDispatch } from 'react-redux';



function Home() {
  let theme = useTheme()
  let navigate = useNavigate()
  let dispatch = useDispatch()
  const { t } = useTranslation()
  const [formData, setFormData] = useState({
    subject: [],
    date: '',
    startTime: '',
    endTime: '',
    tutoringType: ['REMOTE'],
    duration: 'RECURRING',
  });

  let searchHandler = (e) => {
    e.preventDefault()
    console.log(formData)
    const searchParams = {
      subjects: formData.subject, 
      tutoringOptions: formData.tutoringType,
      date: formData.date || undefined,
      startTime: formData.startTime || undefined,
      endTime: formData.endTime || undefined,
      duration: formData.duration || undefined
    }
    dispatch(setFilter(searchParams))
    dispatch(searchTutors({
      subjects: formData.subject, 
      tutoringOptions: formData.tutoringType,
      date: formData.date || undefined,
      startTime: formData.startTime || undefined,
      endTime: formData.endTime || undefined
    }))
    navigate('/result')
  }

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setPosition((prev) => (prev + 1) % 3);
  //   }, 10000);
  //   return () => clearInterval(interval);
  // }, []);

  return (
    <Box sx={{ mt: '-44px' }}>
      {/* Hero Section */}
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          position: 'relative',
          overflow: 'hidden',
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `url('/bg4.jpeg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.15,
            filter: 'blur(2px)',
          }
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1, py: 8 }}>
          <Grid container spacing={4} alignItems="center">
            {/* Left Content */}
            <Grid item xs={12} md={5}>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2.5rem', md: '3.5rem', lg: '4rem' },
                  fontWeight: 800,
                  color: 'white',
                  mb: 3,
                  lineHeight: 1.2,
                  letterSpacing: '-1px',
                }}
              >
                {t('home.heroTitle')}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: alpha('#ffffff', 0.9),
                  mb: 4,
                  fontSize: { xs: '1rem', md: '1.25rem' },
                  lineHeight: 1.6,
                }}
              >
                {t('home.heroSubtitle')}
              </Typography>
            </Grid>

            {/* Right Search Card */}
            <Grid item xs={12} md={7}>
              <Card
                elevation={24}
                sx={{
                  borderRadius: 4,
                  p: { xs: 3, md: 4 },
                  background: alpha('#ffffff', 0.98),
                  backdropFilter: 'blur(20px)',
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    mb: 3,
                    textAlign: 'center',
                  }}
                >
                  {t('home.searchPlaceholder')}
                </Typography>
                
                <Stack spacing={3}>
                  {/* Subject Search */}
                  <TextField
                    variant="outlined"
                    size="large"
                    fullWidth
                    value={formData.subject}
                    onChange={(e) => setFormData({ ...formData, subject: [e.target.value] })}
                    placeholder={t('home.searchPlaceholder')}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search sx={{ color: theme.palette.primary.main }} />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 3,
                        bgcolor: alpha(theme.palette.primary.main, 0.05),
                        '&:hover': {
                          bgcolor: alpha(theme.palette.primary.main, 0.08),
                        },
                        '&.Mui-focused': {
                          bgcolor: 'white',
                          boxShadow: `0 0 0 3px ${alpha(theme.palette.primary.main, 0.2)}`,
                        }
                      }
                    }}
                  />

                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      gap: 2,
                      width: '100%',
                    }}
                  >

                    {/* Where/Tutoring Type */}
                    <TextField
                      select
                      variant="outlined"
                      size="medium"
                      fullWidth
                      value={formData.tutoringType}
                      onChange={(e) => setFormData({ ...formData, tutoringType: [e.target.value]})}
                      placeholder={t('home.where')}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationOn sx={{ color: theme.palette.primary.main }} />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          bgcolor: alpha(theme.palette.primary.main, 0.05),
                          '&:hover': {
                            bgcolor: alpha(theme.palette.primary.main, 0.08),
                          },
                        }
                      }}
                    >
                      <MenuItem value="REMOTE">{t('common.online')}</MenuItem>
                      <MenuItem value="IN_PERSON">{t('common.inPerson')}</MenuItem>
                    </TextField>

                    {/* Duration */}
                    <TextField
                      select
                      variant="outlined"
                      size="medium"
                      fullWidth
                      value={formData.duration}
                      onChange={(e) => setFormData({ ...formData, duration: e.target.value })}
                      placeholder={t('home.duration')}
                      displayEmpty
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Schedule sx={{ color: theme.palette.primary.main }} />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          bgcolor: alpha(theme.palette.primary.main, 0.05),
                          '&:hover': {
                            bgcolor: alpha(theme.palette.primary.main, 0.08),
                          },
                        }
                      }}
                    >
                      <MenuItem value="" disabled>
                        <em>{t('home.duration')}</em>
                      </MenuItem>
                      <MenuItem value="ONE_TIME">{t('home.oneTime')}</MenuItem>
                      <MenuItem value="RECURRING">{t('home.recurring')}</MenuItem>
                    </TextField>
                    
                    {/* When */}
                    <TextField
                      variant="outlined"
                      size="medium"
                      fullWidth
                      value={formData.date}
                      onChange={(e) => setFormData({ ...formData, date: e.target.value, startTime: '', endTime: '' })}
                      placeholder={t('home.when')}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <DateRange sx={{ color: theme.palette.primary.main }} />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 3,
                          bgcolor: alpha(theme.palette.primary.main, 0.05),
                          '&:hover': {
                            bgcolor: alpha(theme.palette.primary.main, 0.08),
                          },
                        }
                      }}
                    />
                  </Box>

                  {/* Time Window - Show when date is selected */}
                  {formData.date && (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 2,
                        width: '100%',
                      }}
                    >
                      <TextField
                        variant="outlined"
                        size="medium"
                        fullWidth
                        value={formData.startTime}
                        onChange={(e) => setFormData({ ...formData, startTime: e.target.value })}
                        placeholder={t('home.startTime') || 'Start Time'}
                        type="time"
                        InputLabelProps={{ shrink: true }}
                        label={t('home.startTime') || 'Start Time'}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <TimeIcon sx={{ color: theme.palette.primary.main }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                            bgcolor: alpha(theme.palette.primary.main, 0.05),
                            '&:hover': {
                              bgcolor: alpha(theme.palette.primary.main, 0.08),
                            },
                          }
                        }}
                      />
                      <TextField
                        variant="outlined"
                        size="medium"
                        fullWidth
                        value={formData.endTime}
                        onChange={(e) => setFormData({ ...formData, endTime: e.target.value })}
                        placeholder={t('home.endTime') || 'End Time'}
                        type="time"
                        InputLabelProps={{ shrink: true }}
                        label={t('home.endTime') || 'End Time'}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <TimeIcon sx={{ color: theme.palette.primary.main }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                            bgcolor: alpha(theme.palette.primary.main, 0.05),
                            '&:hover': {
                              bgcolor: alpha(theme.palette.primary.main, 0.08),
                            },
                          }
                        }}
                      />
                    </Box>
                  )}

                  {/* Search Button */}
                  <Button
                    onClick={searchHandler}
                    fullWidth
                    size="large"
                    sx={{
                      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                      color: theme.palette.secondary.main,
                      textTransform: 'capitalize',
                      py: 1.5,
                      borderRadius: 3,
                      fontWeight: 700,
                      fontSize: '1.1rem',
                      boxShadow: `0 4px 20px ${alpha(theme.palette.primary.main, 0.4)}`,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: `0 6px 25px ${alpha(theme.palette.primary.main, 0.5)}`,
                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                      }
                    }}
                    disableElevation
                    variant='contained'
                  >
                    <Search sx={{ mr: 1 }} />
                    {t('home.search')}
                  </Button>
                </Stack>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Features Section */}
      <Box id="why-choose-us" sx={{ py: 8, bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              color: theme.palette.primary.main,
              mb: 6,
            }}
          >
            {t('home.whyChoose')}
          </Typography>
          <Grid container spacing={4}>
            {[
              { icon: <School sx={{ fontSize: 50 }} />, title: t('home.expertTutors'), desc: t('home.expertTutorsDesc') },
              { icon: <TrendingUp sx={{ fontSize: 50 }} />, title: t('home.flexibleLearning'), desc: t('home.flexibleLearningDesc') },
              { icon: <People sx={{ fontSize: 50 }} />, title: t('home.personalizedSupport'), desc: t('home.personalizedSupportDesc') },
            ].map((feature, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    p: 4,
                    textAlign: 'center',
                    borderRadius: 3,
                    bgcolor: 'white',
                    height: '100%',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: `0 8px 30px ${alpha(theme.palette.primary.main, 0.2)}`,
                    }
                  }}
                >
                  <Box sx={{ color: theme.palette.primary.main, mb: 2 }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 700, color: theme.palette.primary.main, mb: 1 }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                    {feature.desc}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* About Us Section */}
      <Box id="about-us" sx={{ py: { xs: 6, md: 10 }, bgcolor: 'white' }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            {/* Left Content */}
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  color: theme.palette.primary.main,
                  mb: 3,
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  lineHeight: 1.2,
                }}
              >
                {t('home.aboutUsTitle')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  mb: 3,
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  lineHeight: 1.8,
                  textAlign: 'justify',
                }}
              >
                {t('home.aboutUsDesc')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  fontSize: { xs: '1rem', md: '1.1rem' },
                  lineHeight: 1.8,
                  textAlign: 'justify',
                }}
              >
                {t('home.aboutUsDesc2')}
              </Typography>
            </Grid>

            {/* Right Stats/Values */}
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                {[
                  {
                    icon: <Lightbulb sx={{ fontSize: 40 }} />,
                    title: t('home.aboutValue1'),
                    desc: t('home.aboutValue1Desc'),
                  },
                  {
                    icon: <Verified sx={{ fontSize: 40 }} />,
                    title: t('home.aboutValue2'),
                    desc: t('home.aboutValue2Desc'),
                  },
                  {
                    icon: <AccessTime sx={{ fontSize: 40 }} />,
                    title: t('home.aboutValue3'),
                    desc: t('home.aboutValue3Desc'),
                  },
                ].map((value, index) => (
                  <Grid item xs={12} sm={4} md={12} key={index}>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        p: 2,
                        borderRadius: 2,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          bgcolor: alpha(theme.palette.primary.main, 0.05),
                          transform: 'translateX(8px)',
                        }
                      }}
                    >
                      <Box
                        sx={{
                          color: theme.palette.primary.main,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {value.icon}
                      </Box>
                      <Box>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            color: theme.palette.primary.main,
                            mb: 0.5,
                            fontSize: { xs: '1rem', md: '1.1rem' },
                          }}
                        >
                          {value.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: 'text.secondary',
                            fontSize: { xs: '0.85rem', md: '0.9rem' },
                            lineHeight: 1.6,
                          }}
                        >
                          {value.desc}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* How It Works Section */}
      <Box id="how-it-works" sx={{ py: { xs: 6, md: 10 }, bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              color: theme.palette.primary.main,
              mb: 8,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            {t('home.howItWorks')}
          </Typography>

          <Grid container spacing={4}>
            {[
              {
                icon: <Search sx={{ fontSize: 48 }} />,
                step: '01',
                title: t('home.step1Title'),
                desc: t('home.step1Short'),
              },
              {
                icon: <HowToReg sx={{ fontSize: 48 }} />,
                step: '02',
                title: t('home.step2Title'),
                desc: t('home.step2Short'),
              },
              {
                icon: <Assignment sx={{ fontSize: 48 }} />,
                step: '03',
                title: t('home.step3Title'),
                desc: t('home.step3Short'),
              },
              {
                icon: <CheckCircle sx={{ fontSize: 48 }} />,
                step: '04',
                title: t('home.step4Title'),
                desc: t('home.step4Short'),
              },
            ].map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    textAlign: 'center',
                    borderRadius: 3,
                    border: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                    bgcolor: 'white',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: '4px',
                      background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                      transform: 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.3s ease',
                    },
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: `0 12px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
                      borderColor: theme.palette.primary.main,
                      '&::before': {
                        transform: 'scaleX(1)',
                      },
                    }
                  }}
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 16,
                      right: 16,
                      fontSize: '3rem',
                      fontWeight: 800,
                      color: alpha(theme.palette.primary.main, 0.08),
                      lineHeight: 1,
                    }}
                  >
                    {step.step}
                  </Box>
                  <Box
                    sx={{
                      color: theme.palette.primary.main,
                      mb: 2,
                      mt: 1,
                      position: 'relative',
                      zIndex: 1,
                    }}
                  >
                    {step.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: theme.palette.primary.main,
                      mb: 1.5,
                      fontSize: { xs: '1.1rem', md: '1.2rem' },
                      position: 'relative',
                      zIndex: 1,
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      fontSize: { xs: '0.9rem', md: '0.95rem' },
                      lineHeight: 1.7,
                      position: 'relative',
                      zIndex: 1,
                    }}
                  >
                    {step.desc}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

export default Home;